import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-lead-type-chip',
    templateUrl: './lead-type-chip.component.html',
    styleUrls: ['./lead-type-chip.component.scss'],
})
export class LeadTypeChipComponent implements OnInit {
    @Input() isWarm: 0 | 1;

    constructor() {}

    ngOnInit(): void {}
}
